import { isPresent } from 'javascripts/util/isPresent';
import type ApplicationModel from '../ApplicationModel';
import { type Tag } from '../models';
import RecordFilter from './RecordFilter';

class TagFilter extends RecordFilter {
  matches(record: ApplicationModel & { tags?: Tag[] }) {
    return (
      !this.hasItems ||
      (record.modelConstructor.hasField('tags') &&
        isPresent(record.tags) &&
        record.tags.some(tag => super.matches(tag)))
    );
  }
}

export default TagFilter;
